import classNames from "classnames";

import { DatePicker, DatePickerProps } from "@mui/x-date-pickers/DatePicker";

import { StandardTextFieldProps } from "@mui/material";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { useTranslation } from "next-i18next";

interface InputProps extends StandardTextFieldProps {
  readOnly?: boolean;
}

export interface Props extends DatePickerProps<any> {
  className?: string;
  name?: string;
  inputProps?: InputProps;
  pattern?: string;
}
function MyDatePicker(props: Readonly<Props>) {
  const {
    className,
    inputProps,
    name,
    defaultValue = null,
    onChange: propOnChange,
    ...otherProps
  } = props;

  const [value, setValue] = useState(defaultValue);
  const { t } = useTranslation();

  let theInpuProps = {
    ...inputProps,
  };

  if (theInpuProps && !theInpuProps.title && theInpuProps.required) {
    theInpuProps.title =
      t("Please fill in this field") || "Please fill in this field";
  }

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return (
    <>
      <DatePicker
        value={value || null}
        onChange={(val, context) => {
          setValue(val);
          if (propOnChange) {
            propOnChange(val, context);
          }
        }}
        slotProps={{
          textField: theInpuProps,
        }}
        className={classNames([
          className,
          "sebkort-brand-datepicker",
        ])}
        {...otherProps}
      />
      <input
        type="hidden"
        name={name}
        value={value ? dayjs(value.$d).format("YYYY-MM-DD") : ""}
      />
    </>
  );
}

export default MyDatePicker;
